export type PublicBetGameAction = {
    type: string;
    bet: number;
    selection: string;
    engineRoundId: string;
    gameSessionId: string;
};

export type HeroData = {
    name: string;
    multiplier: number;
    weight: number;
    distance: number;
    position: number;
    finished: boolean;
    time?: string;
    speed?: number;
};

export type RaceTick = {
    raceId: string;
    gameState: GameState;
    raceTick: number;
    type: string;
};

export type AvailableActions = {
    actions: string[];
    gamePhase: string;
    engineRoundId: string;
    connecting: boolean;
    type: string;
};

export const gameStates = ['RACE', 'PLACE_BET', 'NO_MORE_BETS', 'CELEBRATION', 'INIT'] as const;

export type GameState = (typeof gameStates)[number];
export type HeroState = 'idle' | 'run' | 'win';

export type UpdateEvent = RaceTick & {
    horses: HeroData[];
};

export type Payload = RaceTick | UpdateEvent;

export type IConnectionConfig = {
    playerSessionId: string;
    server: string;
    gameId: string;
    accountType: string;
};

export type EventListeners = {
    [K in EventType]?: Array<(data: EventPayloads[K]) => void>;
};
export const events = [
    'common:emoji',
    'common:connection',
    'common:balance',
    'common:public-bet',
    'common:public-win',
    'common:social-layer',
    'gdk:close',
    'gdk:open',
    'gdk:message',
    'gdk:action',
    'gdk:bet',
    'horses:bet',
    'horses:show',
    'horses:tick',
    'horses:update',
    'magic-ui:stomp-action',
    'game:done',
] as const;

export type EventType = (typeof events)[number];

export type EventPayloads = {
    'common:emoji': { emojiMap: string };
    'common:connection': {
        gameSessionId: string;
        userRef: string;
        currency: string;
        jurisdiction: string;
        country: string;
        goosicornUsername: string;
        operatorId: string;
        socialLayerData: unknown | null;
        emojiList: string[];
    };
    'common:balance': {
        currency: string;
        amount: number;
        magicWalletBalance: Record<string, unknown>;
    };
    'common:public-bet': {
        currency: string;
        amount: number;
        gameAction: string;
        goosicornUsername: string;
    };
    'common:public-win': {
        currency: string;
        amount: number;
        gameAction: string;
        goosicornUsername: string;
    };
    'common:social-layer': {
        socialLayerJwt: string;
        socialServiceUrl: string;
        socialFrontEndUrl: string;
    };
    'gdk:close': string;
    'gdk:open': { gameId: string; playerSessionId: string; accountType: string };
    'gdk:message': {
        type: string;
        content: {
            a: number;
        };
    };
    'gdk:action': {
        actionType: string;
        data: {
            bet: number;
        };
    };
    'gdk:bet': { betAmount: number; horseId: number; raceId: string };
    'horses:bet': {
        bet: number;
        selection: string;
        engineRoundId: string;
        potentialWin: number;
        betId: string;
    };
    'horses:show': {
        engineRoundId: string;
        currentState: GameState;
        result: null;
        lastResults: unknown[];
        defaultBet: number;
        betLevels: number[];
    };
    'horses:tick': RaceTick;
    'horses:update': UpdateEvent;
    'magic-ui:stomp-action': {
        bet: number;
        selection: string;
        engineRoundId: string;
        type: string;
    };
    'game:done': {
        bet: number;
        selection: string;
        engineRoundId: string;
        type: string;
    };
};
